import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = ["input"]

  connect() {
    this.min = parseInt(this.element.dataset.min || 1, 10)
    this.max = parseInt(this.element.dataset.max || 999999, 10)

    this.validate()
  }

  increment() {
    let value = this.inputValue + 1

    if (value > this.max) value = this.max

    this.setValue(value)
  }

  decrement() {
    let value = this.inputValue - 1

    if (value < this.min) value = this.min

    this.setValue(value)
  }

  validate() {
    let value = this.inputValue

    if (isNaN(value)) value = this.min
    if (value < this.min) value = this.min
    if (value > this.max) value = this.max

    this.setValue(value, false)
  }

  get inputValue() {
    return parseInt(this.inputTarget.value, 10)
  }

  setValue(value, trigger = true) {
    this.inputTarget.value = value

    if (trigger) {
      this.inputTarget.dispatchEvent(
        new Event("change", { bubbles: true })
      )
    }
  }
}